var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.vm.isLoading)?_c('p-progress-linear',{attrs:{"indeterminate":true}}):_vm._e(),_c('p-request-alert',{model:{value:(_vm.vm.error),callback:function ($$v) {_vm.$set(_vm.vm, "error", $$v)},expression:"vm.error"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }